// Created by carsonaberle at 3/4/21
import React, { useState } from 'react';
import './ui-download-share-content.scss';
import { connect } from 'react-redux';
import { withApollo } from '@apollo/react-hoc';
import UIModal from '../UIModal';
import { commonMapDispatchToProps, commonMapStateToProps } from '../../../utils/Helpers/AppHelper';
import { DownloadIcon, ShareWhite } from '../../../assets/icons';
import DownloadModal from '../../modals/Download';
import { FILE_TYPE_FLOOR_PLAN, FILE_TYPE_IMAGE, FILE_TYPE_VIDEO, USER_ROLE_AFFILIATE } from '../../../utils/Config/Constants';
import { isUserAdminOrRM } from '../../../utils/Helpers/UserHelpers';
import UIIconButton from '../UIIconButton';
import ShareListingModal from '../../modals/ShareListingModal/ShareListingModal';
import UIIcon from '../UIIcon';
import UIHover from '../UIHover/UIHover';
import PropTypes from 'prop-types';
import { UI_ICON_BUTTON_OUTLINE_TYPE, UI_ICON_BUTTON_WHITE_TYPE } from '../UIIconButton/config';

function UIDownloadShareContent(props) {
	const { listing, service, sideBarFiles, className } = props;

	if (listing) {
		const isTypeEmpty = (type) => listing[type] && listing[type].length === 0;
		if (
			(!service && isTypeEmpty('aggregatedImages') && isTypeEmpty('aggregatedVideos') && isTypeEmpty('aggregatedFloorplans')) ||
			props.currentUser.user.role === USER_ROLE_AFFILIATE
		) {
			return null;
		}
	} else if (service) {
		const getFileTypesFromService = (type) => {
			if (sideBarFiles) {
				return sideBarFiles.filter((file) => file.type === type);
			} else {
				return service.files.filter((file) => file.type === type);
			}
		};

		if (
			(!isUserAdminOrRM(props.currentUser.user) &&
				getFileTypesFromService(FILE_TYPE_IMAGE).length === 0 &&
				getFileTypesFromService(FILE_TYPE_VIDEO).length === 0 &&
				getFileTypesFromService(FILE_TYPE_FLOOR_PLAN).length === 0) ||
			props.currentUser.user.role === USER_ROLE_AFFILIATE
		) {
			return null;
		}
	}

	const [shouldShowDownloadModal, showDownloadModal] = useState(false);
	const [shouldShowShareModal, showShareModal] = useState(false);

	const renderDownloadModal = () => {
		const hideModal = () => showDownloadModal(false);

		const downloadFilename = () => {
			if (listing && listing.property && listing.property.address) {
				return listing.property.address;
			}
			if (service && service.property && service.property.address) {
				return service.property.address;
			}
		};
		return (
			<UIModal condition={shouldShowDownloadModal} hideModal={hideModal} className='plModal-zIndex-fix'>
				<DownloadModal
					hideModal={hideModal}
					listingId={listing ? listing.id : undefined}
					serviceId={service ? service.id : undefined}
					downloadFilename={downloadFilename()}
					sideBarFiles={sideBarFiles}
				/>
			</UIModal>
		);
	};

	const renderShareModal = () => {
		const hideShareModal = () => showShareModal(false);
		return (
			<UIModal condition={shouldShowShareModal} hideModal={hideShareModal}>
				<ShareListingModal listing={listing ? listing : service.listing} hideModal={hideShareModal} />
			</UIModal>
		);
	};

	return (
		<div className='uiDownloadContent'>
			<div className='uiDownloadContent__button'>
				<UIIconButton
					className={className}
					type={UI_ICON_BUTTON_WHITE_TYPE}
					icon={DownloadIcon.grey}
					iconStyle={{ width: 24 }}
					textClassname='uiDownloadContent__button--text'
					text={'download'}
					onClick={() => showDownloadModal(true)}
				/>
				{(listing || service) && (
					<UIIconButton type={UI_ICON_BUTTON_OUTLINE_TYPE} className={`${className}`} icon={ShareWhite} onClick={() => showShareModal(true)} text={'share'} />
				)}
			</div>
			{listing && <div className={'pl-separator'} />}
			{renderDownloadModal()}
			{renderShareModal()}
		</div>
	);
}

const requiredPropsCheck = (props, propName, componentName) => {
	if (!props.listing && !props.service) {
		return new Error(`One of 'listing' or 'service' is required by '${componentName}' component.`);
	}
};

UIDownloadShareContent.propTypes = {
	listing: requiredPropsCheck,
	service: requiredPropsCheck,
	className: PropTypes.string
};

export default connect(commonMapStateToProps, commonMapDispatchToProps)(withApollo(UIDownloadShareContent));
